import React, {useEffect, useState, useRef} from 'react';
import Axios from 'axios';
import { Alert } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import '../App.css';
import Pagination from '../components/global/Paginator'
import {exportToExcel} from "../utils/reports/exportToExcel";
import {formatDate} from "../utils/dates";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExcel} from "@fortawesome/free-solid-svg-icons";

function Grillaboticketconsolidadosreport (props){
    const fileInputRef = useRef();
    const searchInput = useRef(null);
    const [show, setShow] = useState(false);
    const [datos, setDatos] = useState([]);
    const [datosBackup, setDatosBackup] = useState([])
    const [datosExport, setDatosExport] = useState([]);
    const [metaData, setMetaData] = useState([])
    const [nextPage, setNextPage] = useState();
    const [previousPage, setPreviousPage] = useState();
    const [idcasino, setIdCasino] = useState()

    const [direccioncasino, setDireccionCasino] = useState()
    const [valorticketcasino, setValorTicketCasino] = useState()
    const [rut, setRut] = useState()
    const [rut2, setRut2] = useState('')
    const [fecha, setFecha] = useState('')
    const [visible, setVisible] = useState('seccionNoVisible')
    const [beneficiariobyuser, setBeneficiariobyuser] = useState([])
    const [selectBeneficiarios, setSelectBeneficiarios] = useState()
    const [beneficiario, setBeneficiario] = useState()
    const [ticketid, setTicketId] = useState()
    const [user, setUser] = useState()
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);
    
    const [tituloAlert1, setTituloAlert1] = useState('')
    const [textoAlert1, setTextoAlert1] = useState('')
    const [claseAlert1, setClaseAlert1] = useState('')    
    const [alert1, setAlert1] = useState(false);

    const [tituloAlert3, setTituloAlert3] = useState('')
    const [textoAlert3, setTextoAlert3] = useState('')
    const [claseAlert3, setClaseAlert3] = useState('')    
    const [alert3, setAlert3] = useState(false);


    const [periodo, setPeriodo] = useState('')
    const [usuario, setUsuario] = useState('')
    const [fechafinal, setFechaFinal] = useState('')
    const [file, setFile] = useState('');
    const [fileName, setFileName] = useState("");
    const [barcode, setBarCode] = useState('')
    const [barcoderest, setBarcoderest] = useState('')
    const [pageNumber, setPageNumber] = useState('')
    const [pageSize, setPageSize] = useState(3);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);   

 

    let statuscall = '' 
    


    const dataList = datos.map((item, i) => 
        <div key={i} className="bg-gray-200 p-6 rounded-lg shadow-md mt-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Detalle Consolidados</h3>
        
        {/* Contenedor con grid de 4 columnas, en pantallas grandes */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        
        {/* Columna 1 */}
        <div className="space-y-2">
            {/* Número de Índice - destacado */}
            <div className="flex justify-end">
            <span className="bg-indigo-600 text-white px-3 py-1 rounded-lg text-xl font-bold">{i + 1}</span>
            </div>

            {/* RUT Cliente */}
            <div className="flex justify-end">
            <span className="font-medium text-gray-500">Usuario:</span>
            <span className="font-semibold text-gray-800">{item.usuario}</span>
            </div>
        </div>

        {/* Columna 2 */}
        <div className="space-y-2">
            {/* Nombre Cliente */}
            <div className="flex justify-end">
            <span className="font-medium text-gray-500">Fecha consumo:</span>
            <span className="font-semibold text-gray-800">{item.fecha_consumo}</span>
            </div>

            {/* RUT Beneficiario */}
            <div className="flex justify-end">
            <span className="font-medium text-gray-500">Alumno:</span>
            <span className="font-semibold text-gray-800">{item.alumno}</span>
            </div>
        </div>

        {/* Columna 3 */}
        <div className="space-y-2">
            {/* Valor Ticket */}
            <div className="flex justify-end">
            <span className="font-medium text-gray-500">Estado pago:</span>
            <span className="font-semibold text-gray-800">{item.estado_pago}</span>
            </div>

            {/* Estado Pago */}
            <div className="flex justify-end">
            <span className="font-medium text-gray-500">Estado consumo:</span>
            <span className="font-semibold text-green-800">{item.estado_consumo}</span>
            </div>
        </div>

        {/* Columna 4 */}
        <div className="space-y-2">
            {/* Estado Consumo */}
            <div className="flex justify-end">
            <span className="font-medium text-gray-500">Casino:</span>
            <span className="font-semibold text-green-800">{item.casino}</span>
            </div>

            {/* Valor ticket */}
            <div className="flex justify-end">
            <span className="font-medium text-gray-500">Valor ticket:</span>
            <span className="font-semibold text-green-800">$ {item.valor_ticket}</span>
            </div>
        </div>
        </div>
    </div>);



    const handleExport = () => {
  
        let idcasino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        Axios.get(process.env.REACT_APP_URLTICKETCONSOLIDADOSREPORTEXCEL, {
            params: {
                casino: idcasino.replace('"', ''),
                periodo: periodo.slice(5, 7) + periodo.slice(0, 4),
                usuario: usuario || ''
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatosExport(response.data.consolidado)
        }).catch(error => {
            return error     
        });

        const formattedData = datosExport.map((consolidado) => ({
            Usuario: consolidado.usuario,
            Fecha_consumo: consolidado.fecha_consumo,
            Alumno: consolidado.alumno,
            Estado_pago: consolidado.estado_pago,
            Estado_consumo: consolidado.estado_consumo,
            Casino: consolidado.casino,
            Valor_ticket: consolidado.valor_ticket
        }))
        exportToExcel(formattedData, `ReportePlanillasConsolidadas_${formatDate()}.xlsx`, "Consolidados");
    };


    const handleKeyDown = (event) => {
        if (event.keyCode === 13)
        {
            setBarCode(event.value)
        }
    }

    const consumirTicket = (e) => {
        if(barcoderest != '')
        {
            let idtrim = barcoderest.trim()
            let id = idtrim.substring(16, idtrim.length)
            Axios.get(process.env.REACT_APP_URLTICKETSCANN, {
                params: {
                    id: id 
                }, 
                headers: {
                    'Access-Control-Allow-Origin' : '*',
                    'Access-Control-Allow-Methods': 'GET, POST',
                    'Access-Control-Allow-Headers': 'Content-Type'
                }
            }).then((response) => {
    
                if(response.data.MessageCode === '0')
                {
                    setTituloAlert3('Consumo por scanner')
                    setTextoAlert3('Ticket Consumido')
                    setClaseAlert3('success')
                    setBarCode('')
                    setAlert3(true)
                    searchInput.current.focus()
                    setTimeout(() => {    
                        setAlert3(false)
                    }, 3000)
                }
                else
                {
                    setTituloAlert3('Consumo por scanner')
                    setTextoAlert3('Ticket Ya Consumido o no Existente')
                    setClaseAlert3('warning')
                    setBarCode('')
                    setAlert3(true)
                    searchInput.current.focus()
                    setTimeout(() => {    
                        setAlert3(false)
                    }, 3000)
                }
            }).catch(error => {
                return error     
            });
        }
        else
        {
            setTituloAlert3('Consumo por scanner')
            setTextoAlert3('Debe scannear el codigo primero')
            setClaseAlert3('warning')
            setAlert3(true)
            setTimeout(() => {    
                setAlert3(false)
            }, 3000)
        }

    }

    const handleBeneficiario = async (e) =>{
        setBeneficiario(e.target.value)
    }

    const handleRut = async (e) =>{
        setRut(e.target.value)
    }    

    const handleRut2 = async (e) =>{
        // Despejar Puntos
        let valor = e.target.value.replace('.','');
        // Despejar Guión
        valor = valor.replace('-','');
                
        // Aislar Cuerpo y Dígito Verificador
        let cuerpo = valor.slice(0,-1);
        let dv = valor.slice(-1).toUpperCase();
                
        // Formatear RUN
        setRut2(cuerpo + '-'+ dv)
        setVisible('seccionNoVisible')
    }

    const handleFecha = async (e) =>{
        setFecha(e.target.value)
        setVisible('seccionNoVisible')
    } 
    
    const handleBarcode = async (e) =>{
        setBarcoderest(e.target.value)
    }

    const putCasino = async () =>{
        let urlput = process.env.REACT_APP_URLPUTCASINO+idcasino.toString()+'/update'
        let authcode = window.localStorage.getItem('MY_APP_STATE_AUTHCODE').replace('"', '')
        const data = {   
            direccion: direccioncasino,
            value_ticket: valorticketcasino,
        };

        const casinoPut = await Axios.put(urlput, data, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
        }}).then(res => statuscall = res).catch(err => statuscall = err.response);
            
        if(statuscall.status == 200)
        {   
            handleGrillaCasino()
            handleClose()
        }
    }

    const handleGrillaCasino = async () =>{
        Axios.get(process.env.REACT_APP_URLCASINO, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data)
            setDatosBackup(response.data)
        }).catch(error => {
            return error     
        });
    }

    const createConsumoManual = async () =>{
        if(beneficiario != '')
        {
            if(fecha != "")
            {
                const data = {
                    tickets:[{
                        user: user,
                        beneficiario: beneficiario,
                        ticket_id: ticketid,
                        fechaconsumo: fecha 
                        }
                    ]
                }
                const res = await Axios.post(process.env.REACT_APP_URLCREATECONSUMO, data,{
                    headers: {
                        'Access-Control-Allow-Origin' : '*',
                        'Access-Control-Allow-Methods': 'GET, POST',
                        'Access-Control-Allow-Headers': 'Content-Type'
                }}).then(res => statuscall = res).catch(err => statuscall = err.response);
                            
                if (statuscall.data.MessageCode == "0")
                {
                    GetTicket()

                    setTituloAlert('Consumo de tickets')
                    setTextoAlert('Consumo creado')
                    setClaseAlert('success')
                    setAlert(true)
                    setTimeout(() => {    
                        setAlert(false)
                        handleClose()
                    }, 3000)
                }
            }
            else
            {
                setTituloAlert('Consumo de tickets')
                setTextoAlert('Debe seleccionar una fecha')
                setClaseAlert('warning')
                setAlert(true)
                setTimeout(() => {    
                    setAlert(false)
                }, 3000)
            }


        }
        else
        {
            setTituloAlert('Consumo de tickets')
            setTextoAlert('Debe seleccionar un beneficiario')
            setClaseAlert('warning')
            setAlert(true)
            setTimeout(() => {    
                setAlert(false)
            }, 3000)
            
        }
    }

    const listBeneficiarios = beneficiariobyuser.map((item, i) =>
        <option key={i} value={item.id}>{item.primer_nombre} {item.primer_apellido}</option>
    )

    const GetTicket = () =>
    {

        let idcasino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        Axios.get(process.env.REACT_APP_URLTICKETCONSOLIDADOSREPORT, {
            params: {
                page: pageNumber || 1,
                pageSize: pageSize || 10,
                casino: idcasino.replace('"', ''),
                periodo: periodo.slice(5, 7) + periodo.slice(0, 4),
                usuario: usuario || ''
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            
            setDatos(response.data.consolidado)
            setDatosBackup(response.data.consolidado)
            setMetaData(response.data.consolidado_metadata)

            setCurrentPage(response.data.consolidado_metadata.currentPage)
            setPageNumber(response.data.consolidado_metadata.currentPage)
            setTotalPages(response.data.consolidado_metadata.totalPages)
        }).catch(error => {
            return error     
        });
    }


    useEffect(() => {
        GetTicket()
        window.addEventListener('keydown', handleKeyDown);
        // cleanup this component
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        }        
    }, [pageNumber]);

    const clickTicket= (item) =>{
        //Setea usuario
        setUser(item.mail)
        setRut(item.rutcliente)

        //Busca beneficiarios por usuario
        Axios.get(process.env.REACT_APP_URLBENEFICIARIOSBYUSERS, {
            params: {
                mail:item.mail 
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setBeneficiariobyuser(response.data.beneficiarios)
            //Setea beneficiario
            //setSelectBeneficiarios(listBeneficiarios)
        }).catch(error => {
            return error     
        });

        //Setea id ticket
        setTicketId(item.ticket_id)

        handleShow()
    }

    const handleClose = () => {
        setRut('')
        setBeneficiario('')
        setFecha('')
        setShow(false)
    }
    const handleShow = () => setShow(true)

    const handleChangeList= (e) => {
        let text = e.target.value;
        const setBusqueda = e.target.value;
        const data = datosBackup
        const newData = data.filter(
            function(item){
                const itemDataUsuario = item.usuario
                const itemDataRutBeneficiario = item.rutbeneficiario
                const itemDatanombre =  (item.nombre ?? '').toUpperCase(); 
                const itemDataapellido = (item.apellido ?? '').toUpperCase()
                const itemDataestadopago = (item.estadopago ?? '').toUpperCase()
                const itemDataestadoconsumo = (item.estadoconsumo ?? '').toUpperCase()
                const itemDatavalor = item.valor
                const campo = itemDataUsuario
                const textData = text.toUpperCase()
                return campo.indexOf(textData) > -1        
            }
        )
        setDatos(newData)
    }

    const handlePageSize  = (e) => {
        setPageSize(e.target.value)
    }

    const handlePageNumber = (e) => {
        setPageNumber(e.target.value)
    }

    const handlePeriodo = (e) => {
        setPeriodo(e.target.value)
    }

    const handleUsuario = (e) => {
        setUsuario(e.target.value)
    }

    const handleFechaFinal = (e) => {
        setFechaFinal(e.target.value)
    }

    const saveFile = (e) => {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
    }
 
    const uploadFile = async (e) => {
        if(file != '')
        {
            let idcasinoappstr = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
            let casino_id = idcasinoappstr.replace('"', '')
            const formData = new FormData();
            formData.append("file", file);
            formData.append("fileName", fileName);
            formData.append("casino_id", casino_id);
        
            try {
              const res = await Axios.post(
                process.env.REACT_APP_URLTICKETPROCESOMASIVO,
                formData
              )
              
              if(res.data.MessageCode == "0")
              {
                fileInputRef.current.value = null  
                setFile('')
                setFileName('')
                setTituloAlert1('Consumo masivo de tickets')
                setTextoAlert1('Archivo Cargado y Procesado Correctamente')
                setClaseAlert1('success')
                setAlert1(true)
                setTimeout(() => {    
                    setAlert1(false)
                }, 3000)
              }
              else
              {
                fileInputRef.current.value = null  
              }
            } catch (ex) {
              console.log(ex);
            }
        }
        else
        {
            setTituloAlert1('Consumo masivo de tickets')
            setTextoAlert1('Debe seleccionar un archivo')
            setClaseAlert1('warning')
            setAlert1(true)
            setTimeout(() => {    
                setAlert1(false)
            }, 3000)
        }
    }



    return(
    <div className='w-full'>
        {/* Zona 1 - Filtros */}
        <div className="bg-white shadow-lg p-6 mx-4 mb-2">
            <h2 className="text-xl font-semibold mb-4">Filtros de Reporte Planillas Consolidadas</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

                {/* Campo Periodo */}
                <div className="flex flex-col">
                    <label htmlFor="periodo" className="text-sm font-medium text-gray-600 mb-1">Periodo</label>
                    <input
                    value={periodo} 
                    onChange={handlePeriodo}
                    type="month" 
                    id="periodo" 
                    className="p-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/* Campo Selección Número de Páginas */}
                <div className="flex flex-col">
                    <label htmlFor="numeroPaginas" className="text-sm font-medium text-gray-600 mb-1">Número de Páginas</label>
                    <input 
                    type="number" 
                    id="numeroPaginas"
                    value={pageSize}
                    onChange={handlePageSize} 
                    min="1" 
                    step="1" 
                    defaultValue="1" 
                    className="p-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/* Campo usuario */}
                <div className="flex flex-col">
                    <label htmlFor="usuario" className="text-sm font-medium text-gray-600 mb-1">Usuario</label>
                    <input 
                    type="text" 
                    id="usuario"
                    value={usuario} 
                    onChange={handleUsuario} 
                    min="1" 
                    step="1" 
                    defaultValue="1" 
                    className="p-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/* Botón Generar Reporte con Icono */}
                <div className="flex flex-col justify-end w-full sm:w-auto">
                <button onClick={GetTicket} className="w-full bg-indigo-600 text-white p-2 text-sm rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 flex items-center justify-center space-x-2">
                    {/* Icono de Reporte */}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-5 w-5 mr-2">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h2M15 3h-6a2 2 0 0 0-2 2v4h10V5a2 2 0 0 0-2-2z" />
                    </svg>
                    {/* Texto del Botón */}
                    Generar Reporte
                </button>
                </div>

                </div>
        </div>



        {/* Zona 2 */}
        <div className="bg-white shadow-lg p-4 mx-4 mb-2">
            {/* Controles de Búsqueda y Exportar */}
            <div className="flex justify-between items-center mb-4">
                        {/* Campo de Búsqueda */}
                        <div className="flex flex-col col-span-1 sm:col-span-2 lg:col-span-1">
                            
                            <div className="flex items-center bg-gray-100 border border-gray-300 rounded-lg">
                            <input 
                                type="search" 
                                id="search"
                                onChange={handleChangeList} 
                                placeholder="Buscar en grilla" 
                                className="p-2 text-sm bg-transparent border-0 outline-none flex-1 rounded-l-lg focus:ring-0" 
                            />
                            <button className="p-2 text-gray-500 bg-transparent rounded-r-lg hover:bg-gray-200">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-5 w-5">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0 0l5 5" />
                                </svg>
                            </button>
                            </div>
                        </div>

                        {/* Botón Exportar a Excel alineado a la derecha */}
                        
                        <div>
                            <button
                                className="items-end h-10 bg-green-800 text-white px-4 py-2 rounded-lg hover:bg-green-600"
                                onClick={handleExport}
                            >
                                <FontAwesomeIcon icon={faFileExcel} className="text-xl mr-2"/>
                                Exportar a Excel
                            </button>
                        </div>
                        
            </div>
            <div className="overflow-y-auto h-[600px] p-4">
                {/* Contenedor para los detalles de los tickets */}
                <div className="space-y-6">
                    {dataList}
                </div>
            </div>
            <div className="w-full mt-4 flex justify-center">
                    <Pagination currentPage={pageNumber} totalPages={totalPages} onPageChange={setPageNumber}/>
            </div>
        </div>

        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Consumir Ticket</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alert
                        ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlert}</Alert.Heading>
                                <p>
                                    {textoAlert}
                                </p>
                        </Alert>
                        :''
                        }
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Rut Cliente                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' disabled='true' value={rut}></input>
                    </div>
                </div>
                <div className='row'>
                    <div className='col col-lg-4'>
                        Rut Beneficiario     
                    </div>
                    <div className='col col-lg-4'>
                       <select onChange={handleBeneficiario}>
                           <option>Seleccion beneficiario</option>
                           {listBeneficiarios}
                       </select>
                       
                    </div>
                </div>                
                <div className='row'>
                    <div className='col col-lg-4'>
                        Fecha Consumo                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='date' 
                        onChange={handleFecha}  
                       ></input>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button onClick={handleClose}>
                    Cerrar
                </button>
                <button onClick={createConsumoManual}>
                    Consumir
                </button>
            </Modal.Footer>
            <Modal.Footer className={visible}>
            <div>
                <h4>Debe completar todos los campos</h4>
            </div>
            </Modal.Footer>
        </Modal>                                                                                                                                                                                           
    </div> 

    )
}
export default Grillaboticketconsolidadosreport